module.exports = __webpack_public_path__ + "../static/media/datos.3453370c.png";